<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        휴가신청
      </v-col>
    </v-row>

    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field
          class="bottom--box"
          label="선택"
          v-model="gntNm"
          readonly
          @click="gntGubunFlag = !gntGubunFlag"
          append-icon="mdi-chevron-right"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="근태코드"
          v-model="gntCd"
          readonly
          v-show="false"
        ></v-text-field>
        <span v-show="codeShow">
        <v-text-field
        class="bottom--box"
        append-icon="mdi-chevron-right"
        label="대상자녀"
        @click="applLevelSheet1 = !applLevelSheet1"
        v-model="codeNm"
        readonly
        :style="{ display: hideTargetChild ? 'none' : '' }"
      ></v-text-field>
      <v-text-field v-show="false" v-model="code"></v-text-field>
      <span class="stdOnly hide">
        <span id="stdInfo" class="f_red"></span>
        <v-text-field
          class="bottom--box"
          id="occYmd"
          :label="occYmdNm"
          @click="openModal('date_vacation_app')"
          v-model="occYmd"
          readonly
          append-icon="mdi-chevron-right"
          @formchange="setHolidayCnt"
        ></v-text-field>
      </span>
      </span>
        <v-text-field
          class="bottom--box"
          label="사용휴가"
          v-model="useTargetAnnualNm"
          readonly
          @click="useTargetAnnualFlag = !useTargetAnnualFlag"
          append-icon="mdi-chevron-right"
          v-show="useTargetAnnualShow"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="사용연차휴가 코드"
          v-model="useTargetAnnual"
          readonly
          v-show="false"
        ></v-text-field>
      <span v-show="restShow">
      결제 진행 중인 건 포함<br>
      잔여일수: {{ restCnt }}일 / {{ restCntTime }} 시간
      </span>
      <v-text-field
        class="bottom--box"
        id="sYmd"
        label="신청 시작일"
        @click="sYmdDisabled ? null : openModal('date_vacation_app2')"
        v-model="sYmd"
        append-icon="mdi-chevron-right"
        v-show="sYmdShow"
        :readonly="sYmdDisabled"
      ></v-text-field>
      <v-text-field
        class="bottom--box"
        label="신청 종료일"
        id="eYmd"
        @click="openModal('date_vacation_app3')"
        v-model="eYmd"
        readonly
        append-icon="mdi-chevron-right"
        v-show="eYmdShow"
      ></v-text-field>
      <span id="workInfo"></span>
      <span v-show="dayTypeShow">
        <v-text-field
          class="bottom--box"
          label="오전/오후"
          v-model="dayTypeNm"
          readonly
          @click="dayTypeFlag = !dayTypeFlag"
          append-icon="mdi-chevron-right"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="dayType"
          label="오전/오후 코드"
          v-model="dayType"
          readonly
          v-show="false"
        ></v-text-field>
        </span>
        <v-text-field
          class="bottom--box"
          id="requestHour"
          label="신청시간"
          v-model="requestHour"
          :readonly="requestHourReadOnly"
          @change="changeRequestHour"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
        ></v-text-field>
        <span v-show="dayShow">
        <v-text-field
          class="bottom--box"
          id="holDay"
          label="총일수"
          v-model="holDay"
          readonly
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="closeDay"
          label="적용일수"
          v-model="closeDay"
          readonly
        ></v-text-field>
        </span>
        <span v-show="hourSHow">
        <v-text-field
          class="bottom--box"
          id="reqSHm"
          label="시작시간"
          v-model="reqSHm"
          readonly
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="reqEHm"
          label="종료시간"
          v-model="reqEHm"
          readonly
        ></v-text-field>
        </span>
        <v-text-field
          class="bottom--box"
          id="baseCnt"
          label=""
          v-model="baseCnt"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="maxCnt"
          label=""
          v-model="maxCnt"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="srcYy"
          label="사용연차내역 년도"
          v-model="srcYy"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="srcGntCd"
          label="사용연차내역 근태코드"
          v-model="srcGntCd"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="srcUseSYmd"
          label="사용연차내역 사용기준시작일"
          v-model="srcUseSYmd"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          id="srcUseEYmd"
          label="사용연차휴가 사용기준종료일"
          v-model="srcUseEYmd"
          readonly
          v-show="false"
        ></v-text-field>
        <v-text-field  v-show="replaceShow"
          class="bottom--box"
          label="대리 업무자"
          id="subSabun"
          @click="openModal('search_vacation_executives')"
          v-model="subSabunNm"
          readonly
          append-icon="mdi-chevron-right"
      ></v-text-field>
      <v-text-field
          class="bottom--box"
          label="대리 업무자 사번"
          id="subSabun"
          v-model="subSabun"
          readonly
          append-icon="mdi-chevron-right"
          v-show="false"
      ></v-text-field>
      <v-text-field v-show="gntReqResonShow"
          class="bottom--box"
          label="비고"
          id="gntReqReson"
          v-model="gntReqReson"
      ></v-text-field>
      <div class="borderLine-wrap" v-show="fileShow">
        <span class="borderLine-title">첨부파일</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="fileFlag = !fileFlag"
        >
          <v-icon size="24" color="#9ca3ab">mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <bgf-attach-file-add ref="bgfAttachFile" />
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
    <bgf-attach-file-bottom-select
      :flag="fileFlag"
      @selectItem="changeFile"
    ></bgf-attach-file-bottom-select>
    <v-bottom-sheet v-if="gntGubunFlag" v-model="gntGubunFlag">
      <bottom-sheet :title="selecttitle1" :default="gntCd" :items="gntGubunList" @selectItem="changeBottom1"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="dayTypeFlag" v-model="dayTypeFlag">
      <bottom-sheet :title="selecttitle2" :default="dayType" :items="dayTypeList" @selectItem="changeBottom2"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="useTargetAnnualFlag" v-model="useTargetAnnualFlag">
      <bottom-sheet :title="selecttitle3" :default="useTargetAnnual" :items="useTargetAnnualList" @selectItem="changeBottom3"></bottom-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-if="applLevelSheet1" v-model="applLevelSheet1">
      <bottom-sheet :title="selecttitle4" :default="code" :items="codeList1" @selectItem="changeApplLine1"></bottom-sheet>
    </v-bottom-sheet>
<!--    <bottom-select-->
<!--      :flag="gntGubunFlag"-->
<!--      :list="gntGubunList"-->
<!--      :title="selecttitle1"-->
<!--      @selectItem="changeBottom1"-->
<!--    ></bottom-select>-->
<!--    <bottom-select-->
<!--      :flag="dayTypeFlag"-->
<!--      :list="dayTypeList"-->
<!--      :title="selecttitle2"-->
<!--      @selectItem="changeBottom2"-->
<!--    ></bottom-select>-->
<!--    <bottom-select-->
<!--      :flag="useTargetAnnualFlag"-->
<!--      :list="useTargetAnnualList"-->
<!--      :title="selecttitle3"-->
<!--      @selectItem="changeBottom3"-->
<!--    ></bottom-select>-->
<!--    <bottom-select-->
<!--      :flag="applLevelSheet1"-->
<!--      :list="codeList1"-->
<!--      :title="selecttitle4"-->
<!--      @selectItem="changeApplLine1"-->
<!--    ></bottom-select>-->
    <date-vacation-dialog1 />
    <date-vacation-dialog2 />
    <date-vacation-dialog3 />
     <!-- [모달] 임직원검색 -->
     <search-executives-vacation-dialog
        v-on:clickEmpSelect="addEmp"
      ></search-executives-vacation-dialog>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg
import { mapGetters } from 'vuex';
import {
  getVacationAppDetGntCdList,
  getVacationAppDetHolidayCnt,
  getVacationAppUseCdList,
  getVacationAppDetValidate,
  getApplYnChk,
  getTimeCdMgr,
  getGenderNm,
  getEdusAppDetTgtInfoList,
  getVacationAppDetLogicCheck,
  getVacationAppUseCdList2,
} from '@/api/workStatus';


import dayjs from 'dayjs';
import routerNames from '@/const/routerConstants';
import BgfAttachFileAdd from '@/components/application/form/BgfAttachFileAdd.vue';
import BgfAttachFileBottomSelect from '@/components/application/form/BgfAttachFileBottomSelect.vue';
import BottomSelect from '@/components/application/form/BottomSelect.vue';
import DateVacationDialog1 from '@/components/application/dialog/DateVacationDialog1.vue'; // modal component
import DateVacationDialog2 from '@/components/application/dialog/DateVacationDialog2.vue'; // modal component
import DateVacationDialog3 from '@/components/application/dialog/DateVacationDialog3.vue'; // modal component
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **
import SearchExecutivesVacationDialog from '@/components/application/dialog/SearchExecutivesVacationDialog.vue';
import BottomSheet from "@/components/application/form/BottomSheet.vue"; // 임직원검색 modal component

export default {
  mixins: [dialogMixin],
  data: () => ({
    gntGubunFlag: false, // 화면플래그
    fileFlag: false,
    dayTypeFlag:  false,
    useTargetAnnualFlag: false,
    applLevelSheet1: false, // 대상자명 화면플래그
    selecttitle1: '선택',
    selecttitle2: '오전/오후',
    selecttitle3: '사용휴가',
    gntGubunList: [],
    dayTypeList: [],
    useTargetAnnualList: [],
    codeList1: [],
    gntCd: '',
    gntNm: '',
    sYmd: '',
    eYmd: '',
    occYmd: '',
    restCnt: '',
    restCntTime: '',
    restShow: false,
    holDay: '',
    closeDay: '',
    requestHour: '',
    restDayTime: '',
    dayType: 'AM',
    dayTypeNm: '오전',
    reqSHm: '',
    reqEHm: '',
    useTargetAnnualNm: '',
    useTargetAnnual: '',
    sYmdShow: true,
    dayYn: 'Y',
    useTargetAnnualShow: true,
    srcYy: '',
    srcGntCd: '',
    srcUseSYmd: '',
    srcUseEYmd: '',
    baseCnt: '',
    maxCnt: '',
    validRequestHour: 0.125,
    dayShow: true,
    hourSHow: false,
    dayTypeShow: false,
    dayTypeDisabled : false,
    requestHourReadOnly:  true,
    eYmdShow: true,
    sYmdDisabled:  false,
    subSabun: '',
    subSabunNm: '',
    returnValue: true,
    gntReqReson: '',
    fileShow: true,
    gntReqResonShow: true,
    selecttitle4: '대상자',
    code: '',
    codeNm: '',
    famNmBirth: '',
    occYmdNm:'기준일',
    codeShow: false,
    stdApplyHour: 0,
    fileChek: true,
    replaceShow: true,
    hideTargetChild : false,
  }),

  computed: {
    ...mapGetters('ELA', [
      'GET_APPL_SEQ_EXIST',
      'GET_REFER_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
      'GET_APPL_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_VACCINATION_PARAM',
    ]),
    ...mapGetters([
      'GET_USER_DATA',
      'GET_FAMRSHIPCD_CD',
      'GET_TGT_NAME',
      'GET_FILE_SEQ',
      'GET_PARAMS',
      'GET_VACATION_GNT_GUBUN_MENU',
      'GET_GNT',
      'GET_VACATION_HOLIDAY_CNT',
      'GET_USER_TARGET_ANNUAL',
    ]),
  },

  watch: {
    gntCd: {
        handler: function(v) {
            this.setHolidayCnt();
            this.dateCheck("sYmd");
        },
        deep: true
    },

    occYmd: {
        handler: function(v) {
            this.setHolidayCnt();
            this.dateCheck("occYmd");

            if (this.GET_VACATION_GNT_GUBUN_MENU.gntUse === "Y" && this.GET_GNT.vacationApplYn === "Y"){//신청생성인경우(기준일이 조건이 된다.)
             this.useTargetAnnualNm = "";
              this.initUseTargetAnnual();
            }
        },
        deep: true
    },

    sYmd: {
        handler: function(v) {

          this.setHolidayCnt();

          if(!this.eYmdShow) {
            this.eYmd = this.sYmd;
            setTimeout(() => this.dateCheck('sYmd'), 100);
          } else {
            if (parseInt(dayjs().format('YYYY')) > parseInt(this.sYmd.substring(0, 4)) ||
                parseInt(dayjs().format('YYYY')) < parseInt(this.sYmd.substring(0, 4))) {
              alert('근태/휴가 신청은 당해년도만 가능합니다.');
              this.sYmd = '';
              return;
            }
            this.dateCheck("sYmd");
          }

        },
        deep: true
    },

    eYmd: {
        handler: function(v) {
            this.setHolidayCnt();
            if(this.eYmdShow && this.eYmd !== '') {
              this.dateCheck("eYmd");
            }

            if (this.GET_GNT.vacationYn === 'Y' && this.restCnt !== 0 && this.restCntTime !== 0) {
              // 20240625 제거해달라는 변수석님 요청으로 false로 변경
              //this.restShow = true;
              this.restShow = false;
            } else {
              this.restShow = false;
            }
           
            this.hideReason();
            this.initUseTargetAnnual();

        },
        deep: true
    },
  },

  methods: {

    async changeApplLine1(levelObj) {
      console.dir(levelObj);
      this.code = levelObj.code;
      this.codeNm = levelObj.codeNm;
      this.tgtBirthYmd = levelObj.famYmd;
      this.genderCd = levelObj.genderCd;
      
      this.occYmd = "";
      this.useTargetAnnualNm = "";
      this.initUseTargetAnnual();
      // 대상자명선택화면닫기
      this.applLevelSheet1 = false;
    },

    addEmp(employee) {
      console.dir(employee);
      this.subSabunNm = employee.name;
      this.subSabun = employee.sabun;
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'search_vacation_executives');
    },

    openModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
    },

    changeBottom1(obj) {
      console.dir(obj);

      this.gntCd = obj.code;
      this.gntNm = obj.codeNm;
      this.$store.commit('SET_GNT', obj);

      if (this.GET_GNT.vacationYn === 'Y') {
        //this.restShow = true;
        this.restShow = false;
      } else {
        this.restShow = false;
      }

      this.changeGntCd(this.gntCd);


      this.gntGubunFlag = false;

      if (this.useTargetAnnualShow) {
        if(this.useTargetAnnualList.length === 0) {
          alert('사용할수 없는 휴가입니다');
        }
      }

      this.hourCheck();

      if (this.gntCd === '14' || this.gntCd === '1') {
        this.dayType = '';
        this.dayTypeNm = '';
      }
    },

    changeBottom2(obj) {
      console.dir(obj);

      this.dayType = obj.code;
      this.dayTypeNm = obj.codeNm;
      
      if (this.gntCd === '19' || this.gntCd === '6') {
          this.requestHour = 2;
        }

      
      if (this.dayType === ""){	//(출퇴근 고정이 아닌경우)
        $("#reqSHm").attr("readonly", false);
        $("#reqSHm").removeClass("readonly");
      }else{
        
        $("#reqSHm").attr("readonly", true);
        $("#reqSHm").addClass("readonly");


        if (this.dayType === "AM"){
          this.reqSHm = this.formatTime($("#workInfo").data("workShm"));
          this.reqEHm = this.formatTime($("#workInfo").data("workEhm"));
          //this.reqEHm = ''
        }else{
          //this.reqSHm = '';
          this.reqSHm = this.formatTime($("#workInfo").data("workShm"));
          this.reqEHm = this.formatTime($("#workInfo").data("workEhm"));
        }


        this.hourCheck();


      }



      this.dayTypeFlag = false;
    },

    changeBottom3(obj) {
      console.dir(obj);

      this.useTargetAnnual = obj.code;
      //this.useTargetAnnualNm = obj.codeNm;

      this.useTargetAnnualNm = obj.codeNmView;

      this.$store.commit('SET_USER_TARGET_ANNUAL', obj);
      this.useTargetAnnualFlag = false;
    },

    changeFile(levelObj) {
      if (levelObj === 'C') {
        this.$refs.bgfAttachFile.callCamera();
      } else if (levelObj === 'G') {
        this.$refs.bgfAttachFile.callGallery();
      }

      this.fileFlag = false;
    },

    async setHolidayCnt() {

      let params = {
        sabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        gntCd: this.gntCd,
        sYmd: this.sYmd.replaceAll('-', ''),
        eYmd: this.eYmd.replaceAll('-', ''),
        occYmd: this.occYmd.replaceAll('-', ''),
      }

      let response;

      if (this.sYmd !== '' && this.eYmd !== '') {
        response = await getVacationAppDetHolidayCnt(params);
      }

      // console.log('getVacationAppDetHolidayCnt : '+JSON.stringify(response))

      if (response !== undefined) {
        if (response.data.data != null) {
          this.restCnt = response.data.data.restCnt;
          this.restCntTime = response.data.data.restCntTime;
          let dayBetween = this.getDaysBetween(this.sYmd.replaceAll('-', ''), this.eYmd.replaceAll('-', ''));
          this.holDay = dayBetween;
          this.closeDay = dayBetween - response.data.data.holidayCnt;
          this.requestHour = response.data.data.workFullTimeHour;
          this.$store.commit('SET_VACATION_HOLIDAY_CNT', response.data.data);
        }
      }

      if (this.gntCd === '90') {
        this.useTargetAnnualNm = '';
        this.useTargetAnnual = '';
      }

      if (this.gntCd === '30') {
        this.sYmd = this.occYmd;
      }

      /*
      if (this.GET_GNT.vacationYn === 'Y') {
        this.restShow = true;
      } else {
        this.restShow = false;
      }
      */
    },

    changeRequestHour() {

      if(parseInt(this.requestHour) <= 1) {
        alert('연차휴가(시간)의 최소 신청시간: 2시간 입니다.');
        this.requestHour = '';
        return;
      }

      let maxUnit =  this.GET_GNT.maxUnit;
			if (this.requestHour*60%maxUnit >0){
				alert("신청단위가 맞지 않습니다.");
				this.requestHour = ''
				return;
			}
			if (this.requestHour*this.validRequestHour > this.GET_GNT.maxCnt){
				alert("신청단위가 넘었습니다. ");
				this.requestHour = ''
				return;
			}

			this.hourCheck();
      this.gntCdMintimeChkAlert();
    },

    async dateCheck(obj){

        try{
          var sYmd 	= this.sYmd.replace(/-/gi, "");
          var eYmd 	= this.eYmd.replace(/-/gi, "");
          var occYmd 	= this.occYmd.replace(/-/gi, "");

          //종일이 아닌경우
          if( sYmd != "" && this.dayYn == "N"  ) {
            this.eYmd = this.sYmd;
            eYmd = sYmd;
          }
          if(sYmd == "" || eYmd == "") return;
          if( eYmd < sYmd  ) {
            alert("시작일과 종료일을 정확히 입력하세요.");

            if (obj === 'sYmd') {
              this.sYmd = ''
              this.eYmd = ''
            } else if (obj == 'eYmd') {
              this.sYmd = ''
              this.eYmd = ''
            }

            return;
          }


          if(!this.gntCdLogicCheck()){
            $(obj).val("");
            return;
          }


          $("#workInfo").text("");

          let params = {
            gntCd: this.gntCd,
            sYmd: this.sYmd.replaceAll('-', ''),
            eYmd: this.eYmd.replaceAll('-', ''),
            occYmd: this.occYmd.replaceAll('-', ''),
          }

          let response = await getVacationAppDetHolidayCnt(params);

          // 날짜체크
          let map = response.data.data;

          /*
          if(this.GET_GNT.vacationYn === "Y" ){
            $("#restDayCnt").text( "기 신청 건 산정 잔여일수 : " + map.restCnt + "일") ;
          }
          */

          if( map.authYn == "N") {  // 2020.02.10 추가
            alert("신청 대상자가 아닙니다.");
            if (obj === 'sYmd') {
              this.sYmd = ''
            } else if (obj === 'eYmd') {
              this.eYmd = ''
            }
            return;
          }

          if( map.useStdYn === "N") {
            alert("신청 가능일을 확인하세요. ["+map.useStdSdate+"~"+map.useStdEdate+"]");
            if (obj === 'sYmd') {
              this.sYmd = ''
            } else if (obj == 'eYmd') {
              this.eYmd = ''
            }
            return;
          }

          var dayBetween = this.getDaysBetween(sYmd, eYmd);
          if(this.dayYn == "Y") {
            this.holday = dayBetween;
            this.closeDay = dayBetween - map.holidayCnt;
            this.restDayTime = map.workFullTimeHour;
          } else {
            //반차, 반반차이면서 휴일로 신청하면 안되도록 수정 (2021.07.07)
            if(map.holidayCnt > 0) {
              alert("휴일입니다.");

              if (obj === 'sYmd') {
                this.sYmd = ''
              } else if (obj === 'eYmd') {
                this.eYmd = ''
              }
              return;
            }

            $("#workInfo").text("("+map.timeNm+":"+this.formatTime(map.workShm)+"~"+this.formatTime(map.workEhm)+")");
            $("#workInfo").data(map);

            // 적용시간 세팅
            if(this.GET_GNT.requestUseType  === "H") {
              // 시간차는 근태코드 최소단위에서 처리
              this.requestHour = 8 * Number(this.GET_GNT.baseCnt);
            }
            else if(this.gntCd === '81' || this.gntCd === '82' || this.gntCd === '150' || this.gntCd === '151')
            {
              this.requestHour = this.stdApplyHour;
            } else {
              // 반차, 반반차는 실 근무에서 처리
              this.requestHour = map.workTimeHour * Number(this.GET_GNT.baseCnt);
            }

            if (this.GET_GNT.baseCnt  === "0.5"){	//반차인경우(시간이 고정됨)
              if (this.dayType == "AM"){
                this.reqSHm = this.formatTime(map.workShm);
                this.reqEHm = this.formatTime(map.halfHoliday1);
              }else{
                this.reqSHm = this.formatTime(map.halfHoliday2);
                this.reqEHm = this.formatTime(map.workEhm);
              }
              var maxCnt = this.GET_GNT.maxCnt;

              this.holday = maxCnt;
              this.colseDay = maxCnt;
            }else{
              if (this.dayType === ""){	//(출퇴근 고정이 아닌경우)
                $("#reqSHm").attr("readonly", false);
                $("#reqSHm").removeClass("readonly");
              }else{
                $("#reqSHm").attr("readonly", true);
                $("#reqSHm").addClass("readonly");
                if (this.dayType === "AM"){
                  this.reqSHm = this.formatTime($("#workInfo").data("workShm"));
                  this.reqEHm = this.formatTime($("#workInfo").data("workEhm"));
                  //this.reqEHm = ''
                }else{
                  //this.reqSHm = '';
                  this.reqSHm = this.formatTime($("#workInfo").data("workShm"));
                  this.reqEHm = this.formatTime($("#workInfo").data("workEhm"));
                }
                this.hourCheck();
              }
            }
          }

        }catch(e){
          alert(e);
        }
      },


    // 사용연차휴가 콤보 생성
	async initUseTargetAnnual() {
		let gntUse = this.GET_VACATION_GNT_GUBUN_MENU.gntUse;		// 연차휴가 차감 근태 여부
		let gntCdDel1 = this.GET_GNT.gntCdDel1;		// 휴가발생 공제연차 코드
    let vacationApplYn = this.GET_GNT.vacationApplYn;

    this.changeUseTargetAnnual();

		// 잔여연차휴가 목록 조회
		if( gntUse == "Y" ) {

      let params = {
        searchGntCd1: this.gntCd,
        searchGntCd2: gntCdDel1,
        sYmd: this.sYmd.replaceAll('-', ''),
        eYmd: this.eYmd.replaceAll('-', ''),
        showAll: 'Y',
      };

      if (this.code !== '') {
        //params.targetAnnualVal = this.code;
        params.targetList = this.code;
        
      }

      if (this.GET_GNT.applChkYn === 'Y' && this.GET_GNT.useStdDateCd !== '') {
        params.occYmd = this.occYmd;
      }

      let response = await getVacationAppUseCdList(params);
      this.useTargetAnnualList = response.data.data;

      if (this.useTargetAnnualList.length === 0 && vacationApplYn === "Y") {
        response = await getVacationAppUseCdList2(params);
        this.useTargetAnnualList = response.data.data;
      }

      if (this.gntCd === '320' && this.codeNm === '') {
        this.useTargetAnnualList = '';
      }

		}
	},

    changeUseTargetAnnual(){
      if (this.GET_GNT.vacationApplYn === "Y" && this.GET_GNT.useStdDateCd === "10" && this.useTargetAnnual === ""){//신청생성이고 근태시작일 동일이고 생성전이면 기준일과 시작일을 같게
        this.sYmd = this.occYmd;
        this.sYmdDisabled = true;
      }else{
        this.sYmdDisabled = false;
      }

      this.gntCdMintimeChkAlert();
    },

    getDaysBetween(startDt, endDt) {
      if (startDt === "" || endDt === "") {
          return "";
      }

      let sDt = new Date(startDt.substring(0, 4), startDt.substring(4, 6) - 1, startDt.substring(6, 8));
      let eDt = new Date(endDt.substring(0, 4), endDt.substring(4, 6) - 1, endDt.substring(6, 8));

      return Math.floor(eDt.valueOf() / (24 * 60 * 60 * 1000) - sDt.valueOf() / (24 * 60 * 60 * 1000) + 1);

    },

    async changeGntCd(gntCd) {

      /*
      if( $("#gntCd").val() === "" ) {
        clearHtml();
        this.dayYn = "Y";
        return;
      }
      */

      let params = {
          searchSabun: this.GET_USER_DATA.ssnSabun,
          searchGntGubunCd: this.GET_VACATION_GNT_GUBUN_MENU.code,
          restCntYn: 'Y',
        };

        params.searchGntCd = this.gntCd;

        let response =  await getTimeCdMgr(params);

        this.stdApplyHour = response.data.data.stdApplyHour;

      //현재 근태코드의 근태신청유형
      var reqUseType = this.GET_GNT.requestUseType;
      var baseCnt    = this.GET_GNT.baseCnt;

      //최소, 최대 기준일수를 보여줌
      this.baseCnt = baseCnt;
      this.maxCnt = this.GET_GNT.maxCnt;

      let gntUse = this.GET_VACATION_GNT_GUBUN_MENU.gntUse;

      if(gntUse === "Y") {
        // 사용연차휴가 콤보 생성
        this.useTargetAnnualShow = true;
        this.initUseTargetAnnual();
      } else {
        this.useTargetAnnualShow = false;
      }

      //기준일 체크 시
      if (this.GET_GNT.applChkYn === "Y"){
        this.codeShow = true;
        $(".stdOnly").show();

        // 보건휴가 대상자녀 안보이도록 수정
         if(this.gntCd.trim() =="30")
         {
            this.hideTargetChild = true;
         }
     //   $(".stdOnly b").text(this.GET_GNT.applStdNm !== ""?this.GET_GNT.applStdNm:"기준일");

        if (this.GET_GNT.useSdateCnt !== "" && this.GET_GNT.useEdateCnt !== "" && this.GET_GNT.useSdateCnt !== null && this.GET_GNT.useEdateCnt != null){
          $("#stdInfo").text("( D-"+this.GET_GNT.useSdateCnt+" ~ D+"+this.GET_GNT.useEdateCnt+" )");
        }
      }else{
        this.codeShow = false;
        $(".stdOnly").hide();
      }

      //근태신청유형에 따라 신청폼을 바꿔주는 화면컨트롤 로직
      //발생휴가 사용인 경우 잔여 표기
      if (this.GET_GNT.vacationYn === "Y"){
        $("#restDayCnt").show();
      }else{
        $("#restDayCnt").hide();
      }

      //휴가형태에 따라
      if( reqUseType == "D" ) {//종일인 경우
        this.dayShow = true;
        this.hourSHow = false;
        this.eYmdShow = true;
        this.dayYn = "Y";
        this.dayTypeShow = false;

      } else {

        this.dayShow = false;
        this.hourSHow = true;
        this.eYmdShow = false;
        this.dayYn = "N";

        if (this.GET_GNT.baseCnt === this.GET_GNT.maxCnt){	//시간 고정인 경우
          this.requestHourReadOnly = true;
        }else{
          this.requestHourReadOnly = false;
        }

        if(reqUseType != "H"){
          this.dayTypeShow = false;
          this.dayTypeDisabled = true;
          this.dayType = reqUseType;
        }else{
          this.dayTypeShow = true;
          this.dayTypeDisabled = false;
          if(this.GET_PARAMS.dayType != undefined || this.GET_PARAMS.dayType != null)
          {            
             this.dayType = this.GET_PARAMS.dayType;
             this.dayTypeNm = this.GET_PARAMS.dayTypeNm;
          }
          else{
             this.dayType = 'AM';
             this.dayTypeNm = '오전';
          }
        }

        if (this.dayType === ""){	//(출퇴근 고정이 아닌경우)
          $("#reqSHm").attr("readonly", false);
          $("#reqSHm").removeClass("readonly");
        }else{
          $("#reqSHm").attr("readonly", true);
          $("#reqSHm").addClass("readonly");
          if (this.dayType === "AM"){
            this.reqSHm = this.formatTime($("#workInfo").data("workShm"));
            this.reqEHm = this.formatTime($("#workInfo").data("workEhm"));
            //this.reqEHm = ''
          }else{
            //this.reqSHm = '';
            this.reqSHm = this.formatTime($("#workInfo").data("workShm"));
            this.reqEHm = this.formatTime($("#workInfo").data("workEhm"));
          }
          this.hourCheck();
        }
      }

      this.dateCheck($("#sYmd"));

      if(!this.gntCdLogicCheck()){
				return;
			}
  },

  clearHtml() {

    $("#applYmd").val( "" ) ;
    $("#sYmd").val( "" ) ;
    $("#eYmd").val( "" ) ;
    $("#holDay").val( "" );
    $("#closeDay").val( "" );
    $("#gntReqReson").val( "" );
    $("#reqSHm").val( "" );
    $("#reqEHm").val( "" );
    $("#requestHour").val( "" );

    $("#restDayTitle").text("") ;
    $("#restDayCnt").text("") ;

    $("#maxCnt").val( "" );
    $("#occCd").val( "" );
    $("#occHoliday").val( "" );
    $("#occYmd").val( "" );
    $("#famCd").val( "" );
    $("#span_occHoliday").html( "" );

    // 사용연차휴가 정보 초기화
    $("#srcYy"     ).val("");
    $("#srcGntCd"  ).val("");
    $("#srcUseSYmd").val("");
    $("#srcUseEYmd").val("");
  },

  hourCheck(){
		if(this.reqSHm === "" && this.reqEHm === "") return;

		var requestUseType = this.GET_GNT.requestUseType;
		var gntUse = this.GET_VACATION_GNT_GUBUN_MENU.gntUse;
		var baseCnt = this.GET_GNT.baseCnt;
		var workMap  = $("#workInfo").data();

		let startTime = this.reqSHm.replace(":", "");
		let endTime   = this.reqEHm.replace(":", "");
		let requestHour = Number(this.requestHour);

		let stndTime = startTime;

		if (this.dayType === "PM")	{
			stndTime = endTime;
		}else{
			if (startTime < workMap["workShm"]){
				alert("근무 시작시간을 확인하세요");
				this.reqSHm = '';
				return;
			}
		}

		if (this.dayType === "PM"){

			let reqSHM = this.addTime(stndTime, requestHour, "-");
			let reqSHm = this.getRestCheckHour(reqSHM, stndTime, "-");

			if (reqSHm < workMap["workShm"]){
				//alert("근무 시작시간을 확인하세요. (신청 시작시간 : " + this.formatTime(reqSHm) + ")")
				//this.reqSHm = '';
				//return;
			}

			this.reqSHm = this.formatTime(reqSHm);
		}else{
			let reqEHM = this.addTime(stndTime, requestHour, "+");
			let reqEHm;

      /*
      if (this.gntCd === '6') {
        reqEHm = this.getRestCheckHour(stndTime, reqEHM, "+");
      } else if (this.gntCd !== '19') {
        reqEHm = this.getRestCheckHour(stndTime, reqEHM, "+") - 100 + '';
      } else {
        reqEHm = this.getRestCheckHour(stndTime, reqEHM, "+");
      }
      */

      reqEHm = this.getRestCheckHour(stndTime, reqEHM, "+");

      /*
			if (reqEHM > workMap["workEhm"]){
				alert("근무 종료시간을 확인하세요. (신청 종료시간 : " + this.formatTime(reqEHm) + ")")
				this.reqEHm = '';
				return;
			}

      */
			this.reqEHm = this.formatTime(reqEHm);

		}

    this.holDay = this.validRequestHour*requestHour;
		this.closeDay = this.validRequestHour*requestHour;
	},

  //휴가시간중 휴식시간이 포함되면 휴시시간만큼 시프트
	getRestCheckHour(pReqSHm, pReqEHm, reqType) {
		if ($("#workInfo").data("restTime") == "") return (reqType=="+"?pReqSHm:pReqEHm);
		let arry = $("#workInfo").data("restTime").split("|");
		if (arry.length ==0) arry = new Array( $("#workInfo").data("restTime"));

		let reqSHm = pReqSHm.replace(":", "");
		let reqEHm = pReqEHm.replace(":", "");

		let addHolTime =0;
		let retTime = (reqType=="+"?reqEHm:reqSHm);
		for (let i=0; i < arry.length; i++)
		{
			let restSHm = arry[i].split("^")[0];
			let restEHm = arry[i].split("^")[1];

			if ((restSHm > reqSHm && restSHm < reqEHm)
					|| (restEHm > reqSHm && restEHm < reqEHm)){
				addHolTime += this.betweenTime(restSHm,restEHm )
			}
		}

		if (addHolTime > 0){	//휴식시간이 포함이면 포함된 휴식시간만틈 더한다.
			retTime = this.addTime(retTime, addHolTime,reqType)
		}
		return retTime;
	},

  betweenTime(shm, ehm) {
		let date1 = new Date(2020, 1, 1, shm.substring(0,2), shm.substring(2,4), 0);
		let date2 = new Date(2020, 1, 1, ehm.substring(0,2), ehm.substring(2,4), 4);
		let betweenTime = Math.floor((date2.getTime() - date1.getTime()) / 1000 / 60 / 60*10)/10;
		return betweenTime;
	},

	addTime(stndTime, addVal, addType) {

		let hh = stndTime.substring(0,2)
		let mm = stndTime.substring(2,4)
		let date = new Date(2020, 1, 1, hh, mm);

		let addHh = Math.ceil(addVal);
		let addMm = (addVal - addHh)*60;

		if (addType== "-"){
			date.setHours(date.getHours() -addHh);
			date.setMinutes(date.getMinutes() -addMm);
			return (date.getHours()<10?"0":"")+date.getHours() +(date.getMinutes()<10?"0":"")+date.getMinutes();
		}else{
			date.setHours(date.getHours() + addHh);
			date.setMinutes(date.getMinutes() + addMm);
			return (date.getHours()<10?"0":"")+date.getHours() +(date.getMinutes()<10?"0":"")+date.getMinutes();
		}
	},

  //날짜 포맷을 적용한다..
  formatTime(strDate, saper) {
			if(strDate == "" || strDate == null) {
				return "";
			}
			if (saper == "" || saper == null) saper = ":";
			if(strDate.length == 4) {
				return strDate.substring(0,2)+saper+strDate.substring(2,4);
			} else if(strDate.length == 6) {
				return strDate.substring(0,2)+saper+strDate.substring(2,4)+saper+strDate.substring(4,6);
			}
		},

    async gntCdLogicCheck(){
		// 난임휴가(유급) 41 , 태아검진 81,82
		switch(this.gntCd){
			case "81" :
			case "82" :
			case "41" :

				// eslint-disable-next-line no-case-declarations
				let params = {
          searchSabun : this.GET_USER_DATA.ssnSabun,
          searchGntCd : this.gntCd,
          searchYmd : this.sYmd.replace(/-/gi, ""),
        }

        // eslint-disable-next-line no-case-declarations
        let map = null;

        if (params.searchYmd !== '') {
          map = await getVacationAppDetLogicCheck(params);
        }
				// eslint-disable-next-line no-case-declarations


        console.log('map : '+JSON.stringify(map));

				if(this.gntCd === '41'){
					if(map.data.data !== null && map.data.data.nanimCheck === 'N'){
						alert("난임휴가(유급) 신청이 먼저 사용되야 합니다.");

						this.gntCd = '40';
            this.gntNm = '난임휴가(유급)'

						this.sYmd = '';
						this.eYmd = '';
						return false;
					}
				}else{
					if(map.data.data !== null && map.data.data.babyCheck === 'N'){
						alert("태아검진 신청시 임산부 보호 신청이 먼저되어야 합니다.");
						this.sYmd = '';
						return false;
					}
				}
				break;
		}
		return true;
	},

    async applovalPage() {

      if (this.gntCd.trim() === '') {
        alert('근태는 필수값입니다');
        return;
      }

	  if (this.codeShow) {
	   if (this.code.trim() === '' && this.gntCd.trim() != '90') {
       if(this.gntCd.trim() != '30'){
           alert('대상자녀 선택은 필수값입니다');
	         return;
       }
	
	    }
	  }

      if (this.useTargetAnnualShow) {
        if( this.useTargetAnnualNm === '') {
            alert("사용 연차휴가를 선택해 주시기 바랍니다.");
            return;
        }
      }

      if (this.sYmd.trim() === '') {
        alert('신청시작일은 필수값입니다');
        return;
      }

      if (parseInt(dayjs().format('YYYY')) > parseInt(this.sYmd.substring(0, 4)) ||
      parseInt(dayjs().format('YYYY')) < parseInt(this.sYmd.substring(0, 4))) {
        alert('근태/휴가 신청은 당해년도만 가능합니다.');
        return;
      }

      if (this.eYmd.trim() === '') {
        alert('신청종료일은 필수값입니다.');
        return;
      }

      if(this.dayTypeShow) {
        if(this.dayTypeNm.trim() === '') {
          alert('오전/오후는 필수값입니다.');
          return;
        }
      }

      if (this.GET_GNT.applChkYn  === "Y"){
        if( this.occYmd === null || this.occYmd.trim() === ""){
          alert("기준일은 필수값입니다.");
          return false;
        }
      }

      if( this.GET_GNT.requestUseType != "D"){
			if( this.reqSHm === null || this.reqSHm.trim() === ""){
				alert("시작시간은 필수값입니다.");
				return false;
			}
			if( this.reqEHm === null || this.reqEHm.trim()  === ""){
				alert("종료시간은 필수값입니다.");
				return false;
			}
		}


    await this.logicValidation();

    if(!this.returnValue) {
      return;
    }

    if(this.subSabun === this.GET_USER_DATA.ssnSabun )
    {
      if( this.GET_USER_DATA.ssnEnterCd !='12')
      {
         alert('본인을 대리업무자로 지정할 수 없습니다.');
         return;
      }
     
    }

    if (this.subSabunNm.trim() === '') 
    {
      // 네트웍스 대리업무자 감추고, 값을 작업자 사번으로 세팅.
      if( this.GET_USER_DATA.ssnEnterCd =='12')
      {
        this.subSabun = this.GET_USER_DATA.ssnSabun;
        this.subSabunNm = this.GET_USER_DATA.ssnName;
      }
      else
      {
        alert('근태신청시 대리업무자 지정해주시기 바랍니다.');
        return;
      }

    }


    if (this.requestHour === undefined || this.requestHour === '' || this.requestHour === null){
        alert('신청시간을 입력해주세요');
        return;
			}

    const param = {
      sYmd : this.sYmd.replaceAll('-', ''),
      eYmd : this.eYmd.replaceAll('-', ''),
    }

    let res = await getApplYnChk(param);

    if (res.data.data.chk === 'Y') {
      alert("해당 기간에 신청 중인 근태가 있습니다.");
      return;
    }

    if (this.fileChek) {
      if(this.GET_FILE_SEQ === '') {
        alert('파일 첨부는 필수 입니다');
        return;
      }
    }

    var reqUseType = this.GET_GNT.requestUseType;

    //종일일 경우 해당 값 저장않함
    if (reqUseType === 'D') {
        this.reqSHm = '';
        this.reqEHm = '';
        // this.requestHour = '';
        this.dayTypeNm = '';
        this.dayType = '';
    }

    const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: this.GET_FILE_SEQ,
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        tgtName: this.GET_USER_DATA.ssnName,
        applTypeCd: '10', //본인신청
        gntNm : this.gntNm,
        gntCd : this.gntCd,

        restCnt : this.restCnt,
        restCntTime : this.restCntTime,

        occYmd : this.occYmd,
        sYmd : this.sYmd,
        eYmd : this.eYmd,

        dayTypeNm : this.dayTypeNm,
        dayType : this.dayType,

        holDay : this.holDay,
        closeDay : this.closeDay,

        reqSHm : this.reqSHm,
        reqEHm : this.reqEHm,
        requestHour : this.requestHour,

        useTargetAnnual : this.useTargetAnnual,
        useTargetAnnualNm : this.useTargetAnnualNm,

        baseCnt : this.baseCnt,
        maxCnt : this.maxCnt,

        srcYy : this.srcYy,
        srcGntCd : this.srcGntCd,
        srcUseSYmd : this.srcUseSYmd,
        srcUseEYmd : this.srcUseEYmd,

        subSabunNm : this.subSabunNm,
        subSabun : this.subSabun,
        gntReqReson: this.gntReqReson,
        gntGubunCd: this.GET_VACATION_GNT_GUBUN_MENU.code,
        codeNm : this.codeNm,
        code : this.code,
      };

      console.dir(params);

      this.$store.commit('SET_AUTHPG', 'A');

      this.$store.commit('SET_PARAMS', params);
      this.$store.dispatch('ELA/SET_VACATION_PARAMS', params);
      this.$router.push(routerNames.ApprovalLine);
    },

    async logicValidation() {

      this.returnValue = true;

      let occYmd 	= this.occYmd.replace(/-/gi, "");
      let sdate = this.sYmd.replace(/-/gi, "") ;
      let edate = this.eYmd.replace(/-/gi, "") ;
      let restCnt = Number(this.GET_USER_TARGET_ANNUAL.restCnt);
      let closeDay = Number(this.closeDay);
      let minusYn = this.GET_USER_TARGET_ANNUAL.minusYn;
      let occDivCnt =  parseInt(this.GET_USER_TARGET_ANNUAL.occDivCnt,10);
      let applCnt = parseInt(this.GET_USER_TARGET_ANNUAL.applCnt,10);
      let vacationApplYn = this.GET_GNT.vacationApplYn;


      if(this.GET_VACATION_GNT_GUBUN_MENU.gntUse === "Y" && vacationApplYn == "N" ){
        if( this.useTargetAnnual === "" || this.useTargetAnnual === "null") {
          alert("사용 연차휴가를 선택해 주시기 바랍니다.");
          this.returnValue = false;
          return;
        }
      }

      // 연차휴가 차감 근태인 경우//
      if(this.GET_VACATION_GNT_GUBUN_MENU.gntUse === "Y" && this.useTargetAnnual !== "" ) {
        // 적용일수가 선택한 잔여연차보다 큰 경우 선택 불가 처리
        // 2025.05.26 JKT. 단축근무자(6H) 잔여개수 체크 오류 조치 start....
        /*
        if( minusYn === "N" && closeDay > restCnt ) {
          alert("사용할수 있는 잔여일수가 부족합니다.");
          this.returnValue = false;
          return;
        }
       */

     let closeDayChkValue = 0;
     console.dir(">> " + this.GET_GNT.requestUseType );

      if (this.GET_GNT.requestUseType == "D") { // 일단위일 경우
	     closeDayChkValue = this.restDayTime;
      } else 
      {                    // 시간단위일 경우
		 closeDayChkValue = this.requestHour;
      }
      
		if( minusYn == "N" && closeDayChkValue > (restCnt*8) ) {
			alert("사용할수 있는 잔여일수가 부족합니다.");
			this.returnValue = false;
			return false;
		}
      // 2025.05.26 JKT. 단축근무자(6H) 잔여개수 체크 오류 조치 end....

        // 분활 횟수 조회
        if (occDivCnt < applCnt){
          alert("신청가능 분할 횟수를 초과하였습니다.\n(분할 가능 횟수 : "+occDivCnt+" / 기 신청 횟수 : "+applCnt+")");
          this.returnValue = false;
          return;
        }

        if (vacationApplYn  == "Y" && occDivCnt < (applCnt+1) && restCnt != this.closeDay){
          alert("신청가능한 마지막 회차입니다. 잔여일수를 확인 후 전부 사용해주세요.");
          this.returnValue = false;
          return;
        }

        this.srcYy = this.GET_USER_TARGET_ANNUAL.yy;
        this.srcGntCd = this.GET_USER_TARGET_ANNUAL.gntCd;
        this.srcUseSYmd = this.GET_USER_TARGET_ANNUAL.useSYmd;
        this.srcUseEYmd = this.GET_USER_TARGET_ANNUAL.useEYmd;


        if(this.srcUseSYmd > this.sYmd.replace(/-/gi,'') || this.srcUseEYmd < this.eYmd.replace(/-/gi,'')){
          alert("해당 사용 휴가의 사용기간은 "+ this.formatDate(this.srcUseSYmd,'-') +"일 부터 "+ this.formatDate(this.srcUseEYmd,'-')+"까지입니다.");
          this.returnValue = false;
          return false;
        }
      }

      if( this.closeDay === "0" ){
        alert("휴일은 신청할 수 없습니다.");
        this.returnValue = false;
        return;
      }

      if( this.closeDay !== "" && this.maxCnt !== "" &&
        parseFloat( this.closeDay ) > parseFloat( this.maxCnt  ) ) {
        alert("최대 "+this.maxCnt +"일 이하로 신청 하셔야 합니다.") ;
        this.returnValue = false;
        return;
      }

      if( this.closeDay !== "" && this.baseCnt !== "" &&
        parseFloat( this.closeDay ) < parseFloat( this.baseCnt ) ) {
        alert("최소 "+this.baseCnt+"일 이상 신청 하셔야 합니다.") ;
        this.returnValue = false;
        return;
      }

      let params = {
        sabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        applSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        gntCd: this.gntCd,
        sYmd: sdate,
        eYmd: edate,
        occYmd: occYmd,
        closeDay: this.closeDay,
        reqSHm: this.reqSHm.replace(/:/gi, ""),
        reqEHm: this.reqEHm.replace(/:/gi, ""),
        srcYy: this.srcYy,
        srcGntCd: this.srcGntCd,
        srcUseSYmd: this.srcUseSYmd,
        dayType: this.dayType,
      }

      let response = await getVacationAppDetValidate(params);
      // console.log('response :'+JSON.stringify(response));

      if( response.data.data.Message !== null && response.data.data.Message  !== "" ) {
        alert(response.data.data.Message);
        this.returnValue = false;
      }
    },
     hideReason(){
        if( this.sYmd.replace(/-/gi, "").substring(4,6) >= "10" &&  this.sYmd.replace(/-/gi, "").substring(4,6) <= "12")
      {
        this.gntReqResonShow = true;

      }
      else
      {
         this.gntReqResonShow = false;
      }
   	},
    
    gntCdMintimeChkAlert(){
		if(this.GET_GNT.appmintimechkyn === 'Y'){
			if(isEmpty(this.GET_USER_TARGET_ANNUAL.restcnt)) return;

			let addHour = ('Y' == dayYn ? this.restDayTime : this.requestHour);

			if(addHour == '')return;

			let minHour = this.GET_GNT.baseCnt * 8; // 기준 신청시간
			let restCnt = this.GET_USER_TARGET_ANNUAL.restcnt * 8 ; // 실제 잔여휴가
			// 조건 (사용시간 - 잔여시간) < 최소시간 true
			// 문구 "잔여 휴가 ?H 남기고 시간차 사용할 때 시간차는 2H 이상 사용가능합니다. 1H은 별도 사용 불가하오니 참고바랍니다.
			if( (restCnt - addHour) < minHour && (restCnt - addHour) > 0){
				let resultRestCnt = (restCnt - addHour);
				let msg = this.gntNm+"은 "+minHour+"H 이상 사용가능합니다. \n"+resultRestCnt+"H은 별도 사용 불가하오니 참고바랍니다.";
				alert(msg);
			}

		}
	},

    //날짜 포맷을 적용한다..
    formatDate(strDate, saper) {
      if(strDate == "" || strDate == null) {
        return "";
      }

      if(strDate.length == 10) {
        return strDate.substring(0,4)+saper+strDate.substring(5,7)+saper+strDate.substring(8,10);
      } else if(strDate.length == 8) {
        return strDate.substring(0,4)+saper+strDate.substring(4,6)+saper+strDate.substring(6,8);
      } else if(strDate.length == 6) {
        return strDate.substring(0,4)+saper+strDate.substring(4,6);
      }
    },

    async setTime() {

      if (this.GET_PARAMS.requestHour !== undefined && this.GET_PARAMS.requestHour !== '') {
        this.requestHour = this.GET_PARAMS.requestHour;
      }

      this.reqSHm = this.GET_PARAMS.reqSHm === undefined ? '' : this.GET_PARAMS.reqSHm;
      this.reqEHm = this.GET_PARAMS.reqEHm === undefined ? '' : this.GET_PARAMS.reqEHm;
    }

  },

  async mounted() {
    // 네트웍스 대리업무자 숨기기
    if( this.GET_USER_DATA.ssnEnterCd =='12')
    {
     this.replaceShow = false;
    } 
  
    let params = {
      searchSabun: this.GET_USER_DATA.ssnSabun,
      searchGntGubunCd: this.GET_VACATION_GNT_GUBUN_MENU.code,
      restCntYn: 'Y',
    };

    let response = await getVacationAppDetGntCdList(params);
    this.gntGubunList = response.data.data;

    this.gntCd = this.gntGubunList[0].code;
    this.gntNm = this.gntGubunList[0].codeNm;

    // console.log('this.GET_VACATION_GNT_GUBUN_MENU : '+JSON.stringify(this.GET_VACATION_GNT_GUBUN_MENU));

    this.dayTypeList.push({code:'AM', codeNm:'오전'});
    this.dayTypeList.push({code:'PM', codeNm:'오후'});

    if (this.GET_VACATION_GNT_GUBUN_MENU.gntUse !== 'Y') {
      this.useTargetAnnualShow = false;
    }

    $(".stdOnly").hide();

    this.gntNm = this.GET_PARAMS.gntNm === undefined ? this.gntGubunList[0].codeNm : this.GET_PARAMS.gntNm;
    this.gntCd = this.GET_PARAMS.gntCd === undefined ? this.gntGubunList[0].code : this.GET_PARAMS.gntCd;

    this.restCnt = this.GET_PARAMS.restCnt === undefined ? '' : this.GET_PARAMS.restCnt;
    this.restCntTime = this.GET_PARAMS.restCntTime === undefined ? '' : this.GET_PARAMS.restCntTime;

    this.occYmd = this.GET_PARAMS.occYmd === undefined ? '' : this.GET_PARAMS.occYmd;
    this.sYmd = this.GET_PARAMS.sYmd === undefined ? '' : this.GET_PARAMS.sYmd;
    this.eYmd = this.GET_PARAMS.eYmd === undefined ? '' : this.GET_PARAMS.eYmd;

    this.dayTypeNm = this.GET_PARAMS.dayTypeNm === undefined ? '' : this.GET_PARAMS.dayTypeNm;
    this.dayType = this.GET_PARAMS.dayType === undefined ? '' : this.GET_PARAMS.dayType;

    this.holDay = this.GET_PARAMS.holDay === undefined ? '' : this.GET_PARAMS.holDay;
    this.closeDay = this.GET_PARAMS.closeDay === undefined ? '' : this.GET_PARAMS.closeDay;

    this.useTargetAnnual = this.GET_PARAMS.useTargetAnnual === undefined ? '' : this.GET_PARAMS.useTargetAnnual;
    this.useTargetAnnualNm = this.GET_PARAMS.useTargetAnnualNm === undefined ? '' : this.GET_PARAMS.useTargetAnnualNm;

    this.baseCnt = this.GET_PARAMS.baseCnt === undefined ? '' : this.GET_PARAMS.baseCnt;
    this.maxCnt = this.GET_PARAMS.maxCnt === undefined ? '' : this.GET_PARAMS.maxCnt;

    this.srcYy = this.GET_PARAMS.srcYy === undefined ? '' : this.GET_PARAMS.srcYy;
    this.srcGntCd = this.GET_PARAMS.srcGntCd === undefined ? '' : this.GET_PARAMS.srcGntCd;
    this.srcUseSYmd = this.GET_PARAMS.srcUseSYmd === undefined ? '' : this.GET_PARAMS.srcUseSYmd;
    this.srcUseEYmd = this.GET_PARAMS.srcUseEYmd === undefined ? '' : this.GET_PARAMS.srcUseEYmd;

    this.subSabunNm = this.GET_PARAMS.subSabunNm === undefined ? '' : this.GET_PARAMS.subSabunNm;
    this.subSabun = this.GET_PARAMS.subSabun === undefined ? '' : this.GET_PARAMS.subSabun;
    this.gntReqReson = this.GET_PARAMS.gntReqReson === undefined ? '' : this.GET_PARAMS.gntReqReson;

    this.codeNm = this.GET_PARAMS.codeNm === undefined ? '' : this.GET_PARAMS.codeNm;
    this.code = this.GET_PARAMS.code === undefined ? '' : this.GET_PARAMS.code;
    //this.$store.commit('SET_GNT', this.gntGubunList[0]);
    this.initUseTargetAnnual();

    params.searchGntCd = this.gntGubunList[0].code;
    response = await getTimeCdMgr(params);

    // console.log('response :: '+JSON.stringify(response));
    //alert(JSON.stringify(this.GET_UI_INFO));
    if (response.data.data.autoAgreeYn === 'Y') {
      this.$store.commit('ELA/SET_ORG_LVL', this.GET_UI_INFO.orgLevelCd);
    }

     //if (response.data.data.noteYn === 'N') {
      //this.gntReqResonShow = false;
    //}
    // 2025.10.22 JKT. 네트웍스의 경우, 10월~12월일 경우 비고 입력기능 추가
    if (response.data.data.noteYn === 'N') {
      this.gntReqResonShow = true;
    }

    
    if (this.GET_UI_INFO.fileYn === 'N') {
      //this.fileShow = false;
      this.fileChek = false;
    } else {
      if (response.data.data.fileYn === 'N') {
        //this.fileShow = false;
        this.fileChek = false;
      }
    }
    

    this.stdApplyHour = response.data.data.stdApplyHour; 

    params = {
      searchApplSabun: this.GET_USER_DATA.ssnSabun,
      searchApplYmd: dayjs().format('YYYYMMDD'),
      searchChildYn: 'Y',
    };

    response = await getEdusAppDetTgtInfoList(params);
    this.codeList1 = response.data.data;

    if(this.gntCd === '320') {
      this.occYmdNm = '배우자출산일';
    } else if (this.gntCd === '90') {
      this.occYmdNm = '출산예정일';
    }else if (this.gntCd === '30') {
      this.occYmdNm = '보건휴가일';
    }

    if(this.GET_PARAMS.gntNm === undefined) {
      this.$store.commit('SET_GNT', this.gntGubunList[0]);
      await this.changeGntCd();
    } else {
      await this.changeGntCd();
    }

    let that = this;

    setTimeout(async function () {
      await that.setTime();
    }, 500);


  },

  components: {
    BottomSheet,
    IconApprovalDoc,
    BgfAttachFileAdd,
    BgfAttachFileBottomSelect,
    BottomSelect,
    DateVacationDialog1,
    DateVacationDialog2,
    DateVacationDialog3,
    SearchExecutivesVacationDialog,
  },
};
</script>

<style>
/* _approval.scss 에 넣음 */
/* dialog */
/* .v-dialog:not(.v-bottom-sheet) {
  background-color: white;
  height: inherit;
} */
</style>
